export default __webpack_public_path__ + "static/media/remove-image.92d1c97e.svg";